const cookieHelper = {
    setCookieData: function (name, value, seconds) {
        try {
            seconds = seconds || 0 // seconds有值就直接赋值，没有为0
            let expires = ''
            if (seconds !== 0) { // 设置cookie生存时间
                let date = new Date()
                date.setTime(date.getTime() + (seconds * 1000 * 60))
                expires = '; expires=' + date.toGMTString()
            }
            document.cookie = name + '=' + escape(value) + expires + '; path=/' // 转码并赋值
        } catch (e) {
            console.error('设置Cookie失败！')
        }
    },
    getCookieData: function (key) {
        try {
            let arr = null
            let reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')
            if (document.cookie.match(reg)) {
                arr = document.cookie.match(reg)
                return unescape(arr[2])
            } else {
                return false
            }
        } catch (e) {
            console.error('读取Cookie失败！')
            return false
        }
    },
    clearCookieData: function () {
        this.setCookieData("KERPSESSIONID", '', -1)
        this.setCookieData("KERPSESSIONIDtenant_devscm_dev", '', -1)
    },
}
export default cookieHelper